module.exports = __webpack_public_path__ + "static/media/get_bg.ec7efeec.jpg";